import * as React from 'react'
import Button, { ButtonAppearance, ButtonSize } from '@envato/foundation-button'

import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'
import ItemsGrid from '../../itemsGrid'
import { IBlockMatchedComponent } from '../../../pages/category/category'
import { urlFromCTA } from '../../../../common/utils/categoryPage'
import { IItem } from '../../../../typings/searchResults'

import * as styles from './itemsBlock.module.css'

interface IProps extends IBlockMatchedComponent {
  data: IItem[]
  title: string
}

const ItemsBlock = ({
  title,
  subtitle,
  cta,
  data,
  location,
  makeSearchLink
}: IProps) => {
  const renderTitle = () => (
    <React.Fragment>
      {title}
      {subtitle && <span>: {subtitle}</span>}
    </React.Fragment>
  )

  const url = urlFromCTA({ cta, makeSearchLink })

  return (
    <section className={styles.root}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          {url && (
            <a
              className={styles.cta}
              href={url}
              onClick={reportCategoryPageClick(title)}
            >
              {renderTitle()}
            </a>
          )}
          {!url && renderTitle()}
        </h2>
        {cta && url && (
          <Button
            href={url}
            appearance={ButtonAppearance.Primary}
            size={ButtonSize.Small}
            className={styles.button}
            onClick={reportCategoryPageClick(title)}
          >
            {cta.title}
          </Button>
        )}
      </header>
      <div className={styles.itemsWrapper}>
        <ItemsGrid
          items={data}
          location={location}
          listName="Category Page"
          showSingleRow
        />
      </div>
    </section>
  )
}

export default ItemsBlock
